module.exports = {"id":"dp2_3l1q2","text":"Engaging in Citizenship through Digital Technologies","instructions":"Digital citizenship mainly refers to:","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_3l1q2-a1","text":"Participating responsibly in online communities","score":1.8},{"id":"dp2_3l1q2-a2","text":"Using the internet only for entertainment","score":0},{"id":"dp2_3l1q2-a3","text":"Buying goods and services online","score":0}],"category":"2.3"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.3/l1q2.json
// module id = 1029
// module chunks = 41